//JoinRoom-Name(CreateRoomDialog)-RoomWords-ChangeName

import React, { useEffect, useState } from 'react';

import { FormControl, Grid, IconButton, Input, InputAdornment, makeStyles, TextField, Tooltip } from '@material-ui/core';
import { CloseSharp, FileCopyOutlined, HistorySharp, MicOutlined, Send, TrainRounded } from '@material-ui/icons';
import Autocomplete from '@material-ui/lab/Autocomplete';


const useStyles = makeStyles((theme)=> ({

    rootFormControl : {
        padding : '0.5vw',
        borderColor : ' #1c1c1c',
        border : '3px solid',
        height : '5vh',
        width : '250px',
        
    },
    joinRoomText : {
        padding : '0.5vw',
        borderColor : ' #1c1c1c',
        border : '3px solid',
        height : '5vh',
        width : '250px',
        marginLeft: "2vw",
        
    },
    joinRoomMobText : {
        padding : '0.5vw',
        borderColor : ' #1c1c1c',
        border : '3px solid',
        height : '8vh',
        width : '250px',
        
    },
    rootInput : {
        color : '#e5e7eb',
        width : '100%',
        height : '100%',
        textAlign : 'center',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    rootMobInput : {
        color : '#e5e7eb',
        width : '100%',
        height : '8vh',
        paddingLeft : '5vw',
        textAlign : 'center',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    joinRoomForm : {
        border : 'solid 1px',
        padding : '0.5vw',
        borderColor : '#fe752f',
        height : '10vh',
        width : '100%',
    },
    defTextField :{
        border : 'solid 1px',
        padding : '0.5vw',
        borderColor : ' #1c1c1c',
    },
    defInput : {
        color : '#fe752f',
        '& .Mui-disabled':{
            color : '#fe752f'
        }
    },
    RoomTxtField : {
        margin: theme.spacing(1),
        width : '20vw',
        padding:'0px',
    },
    AddName : {
        border : 'solid 1px',
        padding : '0.1vh',
        borderColor : '#fe752f',
        height : '5vh',
        width : '100%',
    },
    AddNameInput : {
        color : '#fe752f'
    },
    RoomTxtInputAdorn : {
        padding : '0px',
        color:'red',
        // 'theme.input.MuiInputBase-input.MuiFilledInput-input' : {
        // }
    },
    AutoCompleteText : {
        borderColor : ' #1c1c1c',
        border : 'none',
        height : '7vh',
        justifySelf : 'center',
        width : '60%',
        color : '#e5e7eb',
        margin : '1vw',
        marginLeft : '0',
        textAlign : 'center',
        backgroundColor : '#373737',
        outline : 'none !important',
        "& .MuiOutlinedInput-root" : {
            outline : 'none !important',
            '&:focused :notchedOutline': {
                borderColor: 'green',
                borderWidth: 1,
              },
              '&.Mui-focused fieldset': {
                borderColor: 'black',
              },
        },
        "& .MuiAutocomplete-input": {
            flexGrow: '0',
            color : '#e5e7eb',
        },
        "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
            width: '100%',
        },
        // "& .MuiIconButton-label" : {
        //     width : '2vw',
        //     height : '2vw',
        // },
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& .MuiOutlinedInput-adornedStart" : {
            paddingLeft : '0px',
        },
        "& .MuiOutlinedInput-notchedOutline" : {
            border : 'none',
        },
        '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]' : {
            padding : '0',
            height : '7vh',
        }
        
    },
    AutoCompleteTextInput : {
        color : '#e5e7eb',
        width : '100%',
        height : '100%',
        textAlign : 'center',
        display : 'flex',
        justifyContent : 'flex-start',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        outline : 'none !important',
        paddingRight : '0 !important',
        "& .PrivateNotchedOutline-root" : {
            border : "none !important",
        }
    },
    AutoCompleteTextMob : {
        borderColor : ' #1c1c1c',
        border : 'none',
        height : '6vh',
        justifySelf : 'center',
        width : '80%',
        color : '#e5e7eb',
        textAlign : 'center',
        backgroundColor : '#373737',
        outline : 'none !important',
        "& .MuiOutlinedInput-root" : {
            outline : 'none !important',
            '&:focused :notchedOutline': {
                borderColor: 'green',
                borderWidth: 1,
              },
              '&.Mui-focused fieldset': {
                borderColor: 'black',
              },
        },
        "& .MuiAutocomplete-input": {
            flexGrow: '1',
            color : '#e5e7eb',
        },
        "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
            width: '100%',
        },
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& .MuiOutlinedInput-adornedStart" : {
            paddingLeft : '0px',
        },
        '& .MuiOutlinedInput-input' : {
            padding : '0px !important',
        },
        "& .MuiOutlinedInput-notchedOutline" : {
            border : 'none',
        },
        "& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root .MuiAutocomplete-input" : {
            padding : '14px 10px',
        },
        "& .MuiFormControl-root" : {
            height :"6vh"
        }
    },
    AutoCompleteTextInputMob : {
        color : '#e5e7eb',
        width : '100%',
        height : '8vh',
        textAlign : 'center',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        outline : 'none !important',
        paddingRight : '0 !important',
    },
    ClipText : {
        width : '40%',
        display:'grid', 
        justifySelf:'center',
        gridArea : 'textFeature',
        "& .MuiOutlinedInput-root" : {
            outline : 'none !important',
            '&:focused :notchedOutline': {
                borderColor: 'green',
                borderWidth: 1,
              },
              '&.Mui-focused fieldset': {
                borderColor: '#fe752f',
              },
        },
        "& .MuiAutocomplete-input": {
            flexGrow: '1',
            color : '#e5e7eb',
        },
        "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
            width: '100%',
        },
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& .MuiInputBase-root" : {
            color : "#e5e7eb !important",
            border: '2px solid #343434',
        },
        "&:focus .MuiInputBase-root" : {
            color : "#fe752f !important",
            borderColor : '#fe752f',
        },
        '& .MuiInputBase-input' : {
            width : '25vw',
            minWidth : '250px',
        }
    },
    ClipTextMob : {
        display:'grid', 
        justifySelf:'center',
        gridArea : 'textFeature',
        "& .MuiOutlinedInput-root" : {
            outline : 'none !important',
            '&:focused :notchedOutline': {
                borderColor: 'green',
                borderWidth: 1,
              },
              '&.Mui-focused fieldset': {
                borderColor: '#fe752f',
              },
        },
        "& .MuiAutocomplete-input": {
            flexGrow: '1',
            color : '#e5e7eb',
        },
        "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
            width: '100%',
        },
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& .MuiInputBase-root" : {
            color : "#e5e7eb !important",
            border: '2px solid #343434',
        },
        "&:focus .MuiInputBase-root" : {
            color : "#fe752f !important",
            borderColor : '#fe752f',
        },
        '& .MuiInputBase-input' : {
            width : '25vw',
            minWidth : '250px',
        }
    },
    removeFocus : {
        outline : 'none !important',
    },

}));

export const JoinRoomName = function JoinRoomName(props) {

    const classes = useStyles();
    const [text, setText] = useState('');
    const [show,setShow] = useState(props.show);
    var inputRefD;
    var rooms = JSON.parse(localStorage.getItem("joinRoom"))||{};
    var curRoom = localStorage.getItem("createRoom")||"";
    Object.keys(rooms).forEach(key => {
        if(rooms[key] == curRoom)
            delete rooms[key];
    });

    useEffect(() => {
        setShow(props.show);
        if(show){
            inputRefD.focus();
        }
    },[props.show])
    
        
    var handleDebounceInput = (event) => {
        if(event) {
            event.persist();
            setText(event.target.value); 
            props.textInput(event.target.value);
        }   
    }

    var handleDeletion = (optn) => {
        let key = optn.slice(0, optn.indexOf(':'));
        delete rooms[key];
        let newRoom = JSON.parse(localStorage.getItem("joinRoom"));
        delete newRoom[key];
        localStorage.setItem("joinRoom", JSON.stringify(newRoom));
        setText("")
    }

    

    var handleSuggestion = (event) => {
        event.persist();
        setText(event.target.innerText);
        props.textInput(event.target.innerText);
    }

    // var handleAudioClick = () => {
    //     setDisplay(true);
    //     props.analyzer.receive(()=>{
    //         setDisplay(false);
    //     })
    // }

    return(
        <Autocomplete
        id="free-solo-demoj"
        openOnFocus={true}
        value={text} 
        onChange={ handleSuggestion }
        onInputChange={ handleDebounceInput }
        freeSolo
        options={Object.keys(rooms).map((key) => {
            return (key+":"+rooms[key])
        })}
        renderOption={ (opt) => {
            
            return (
                <div className="oneLineButtons" style={{width:"100%",display:"flex",justifyContent:"space-between"}} >
                    <p>{opt}</p>
                    <IconButton onClick={()=>{ handleDeletion(opt) }} >
                        <CloseSharp />
                    </IconButton>
                </div>
            )
        }}
        closeIcon={ null }
        classes={{ inputRoot : classes.AutoCompleteTextInput ,root : classes.AutoCompleteText }}
        renderInput={(params) => (
            <TextField {...params} 
                autoFocus={false}  
                id="JoinRoomNameDTextField"  
                // value={text} 
                placeholder="Enter code to join portal"  
                variant="outlined"
                inputRef={input => {
                    inputRefD = input;
                  }}
                />
        )}
      />
        // <FormControl autoComplete="off" classes={{ root : classes.joinRoomText }} variant="outlined" >
        //     <Input autoComplete="off" disableUnderline={true} classes={{ input : classes.rootInput }} id="JoinRoomNameTextField" value={text} placeholder="Enter code to join portal" onChange={ handleDebounceInput }  />
        // </FormControl>
    )

    //Audio Button
    // <Tooltip title="Listen Audio QR Code" >
    //     <IconButton onClick={handleAudioClick} disabled={display} > 
    //         <MicOutlined />
    //     </IconButton>
    // </Tooltip>

}

export const ClipTextField = function ClipTextField({ text, handleClipText, handleSendText, from, handleFrom }){

    const classes = useStyles();
    let visibility = (from === "copy" && text !== "") ? null : (from === "text" && text === "") ? null : true;
    if(visibility) {
        visibility = "visible";
    } else {
        visibility = "hidden";
    }
    return (
        <TextField
                autoFocus={false}  
                id="ClipTextTextField"  
                value={text} 
                onChange={ (e)=>{ handleClipText(e.target.value); handleFrom("text"); } } 
                placeholder="Type text to send to receivers"  
                classes={{ root : window.innerWidth<900 ? classes.ClipTextMob :classes.ClipText }}
                variant="outlined"
                InputProps={{
                    endAdornment: <InputAdornment position="end">
                                        <IconButton style={{visibility}} onClick={ ()=>{handleSendText()} } >
                                                <Send />
                                            </IconButton> 
                                    </InputAdornment>,
                    }}
                    />
    )

}

export const JoinRoomMobName = function JoinRoomMobName(props) {

    const classes = useStyles();
    const [text, setText] = useState('');
    const [show,setShow] = useState(props.show);
    var inputRef;
    var rooms = JSON.parse(localStorage.getItem("joinRoom"))||{};
    var curRoom = localStorage.getItem("createRoom")||"";
    Object.keys(rooms).forEach(key => {
        if(rooms[key] == curRoom)
            delete rooms[key];
    });

    useEffect(() => {
        setShow(props.show);
        if(show){
            inputRef.focus();
        }
    },[props.show])
    
    
    var handleDeletion = (optn) => {
        let key = optn.slice(0, optn.indexOf(':'));
        delete rooms[key];
        let newRoom = JSON.parse(localStorage.getItem("joinRoom"));
        delete newRoom[key];
        localStorage.setItem("joinRoom", JSON.stringify(newRoom));
        setText("");
    }

    var handleDebounceInput = (event) => {
        if(event) {
            event.persist();
            setText(event.target.value);
            props.textInput(event.target.value);
        }

    }

    var handleSuggestion = (event) => {
        event.persist();
        setText(event.target.innerText);
        props.textInput(event.target.innerText);
    }

    return(
        <Autocomplete
        id="free-solo-demo"
        openOnFocus={true}
        value={text} 
        onChange={ handleSuggestion }
        onInputChange={ handleDebounceInput }
        freeSolo
        options={Object.keys(rooms).map((key) => {
            return (key+":"+rooms[key])
        })}
        renderOption={ (opt) => {
            return (
                <div className="oneLineButtons" >
                    <p style={{ fontSize:'10px !important' }} >{opt}</p>
                    <IconButton onClick={()=>{ handleDeletion(opt) }} >
                        <CloseSharp />
                    </IconButton>
                </div>
            )
        }}
        closeIcon={ null }
        classes={{ inputRoot : classes.AutoCompleteTextInput ,root : classes.AutoCompleteTextMob }}
        renderInput={(params) => (
            <TextField {...params} 
                autoFocus={false}  
                id="JoinRoomNameTextField"  
                placeholder="Enter code to join portal"  
                variant="outlined"
                inputRef={input => {
                    inputRef = input;
                  }}
                />
        )}
      />
        // <FormControl autoComplete="off" classes={{ root : classes.joinRoomText }} variant="outlined" >
        //     <Input autoComplete="off" disableUnderline={true} classes={{ input : classes.rootInput }} id="JoinRoomNameTextField" value={text} placeholder="Enter code to join portal" onChange={ handleDebounceInput }  />
        // </FormControl>
    )

}


export const AddName = function AddName(props) {

    const [name, setName] = useState('')
    const classes = useStyles();

    var handleNameChange = (event) => {
        event.persist();
        setName(event.target.value);
        props.getName(event.target.value);
    }

    return(
        <FormControl classes={{ root : classes.AddName }} variant="outlined" >
            <Input disableUnderline={true} classes={{ root : classes.AddNameInput }} id="SetUserNameTextField" value={name} placeholder="Enter nick name" onChange={ handleNameChange }  />
        </FormControl>
    )

}

export const NameChangeField = function NameChangeField( { currname, handleChange } ) {

    const classes = useStyles();
    const [name, setName] = useState('')


    useEffect(() => {
        if (currname !== null){
            setName(currname)
        }
        return () => {
        }
    }, [name,currname])

    var handleNameChange = (event) => {
        event.persist();
        setName(event.target.value);
        handleChange(event.target.value);
    }

    return(
        <FormControl classes={{ root : classes.defTextField }} variant="outlined" >
            <Input disableUnderline={true} classes={{ root : classes.defInput }} id="UpdateNameTextField" value={name} onChange={ handleNameChange }  />
        </FormControl>
    )

}

export const KeyField = function KeyField( { currname } ) {

    const classes = useStyles();
    const [name, setName] = useState('')

    useEffect(() => {
        if (currname !== null){
            setName(currname)
        }
        return () => {
        }
    }, [name,currname])

    return(
        <FormControl classes={{ root : classes.defTextField }} variant="outlined" >
            <Input disableUnderline={true} disabled={true} classes={{ root : classes.defInput }}  value={name} />
        </FormControl>
    )

}

export const RoomWords = function RoomWords({roomName , copy}) {

    var handleCopy = (e) => {

        e.preventDefault();
        var copyText = document.getElementById("checking");
        copyText.disabled = false;
        copyText.select();
        document.execCommand("copy");
        copyText.disabled = true;

    }

    return(
        <div style={{ backgroundColor : '#e5e7eb', color: '#242424', display : 'grid', maxWidth : '25vw', minHeight : '5vh', alignContent : 'center' }} >
            <span  >
                <input id="checking" disabled={true}  value={roomName} style={{ marginTop : '1vw' ,alignSelf : 'center' , textAlign : 'center' ,marginLeft: '1vw',fontFamily:'Intern', fontSize : '20px', float : 'left' , border : '0', backgroundColor : '#e5e7eb' }} />
                { copy ? 
                    <IconButton onClick={handleCopy} style = {{ float: 'right' ,width : '5vw' }} >
                        <FileCopyOutlined />
                    </IconButton> :
                    null
                }
            </span>
        </div>
        )
        
}
    
    
    // className={clsx(classes.margin, classes.textField)}
    // <FormControl disabled={true} className={classes.RoomTxtField}  >
    //   <FilledInput
    //     disableUnderline={true}
    //     value={roomName}
    //     endAdornment={
    //         handleCopy()
    //     }
    //   />
    // </FormControl>
    // <TextField disableUnderline={true} disabled={true} value="Kanishq-Room-Words" classes={{ root : classes.RoomTxtField, filled : classes.RoomTxtInputAdorn }} variant="filled"  />

    // var handleCopy = () => {
    //     if (copy) {
    //         return(
    //             <InputAdornment style={{padding : '0px'}} classes = {{ filled : classes.RoomTxtInputAdorn, root : classes.RoomTxtInputAdorn, input : classes.RoomTxtInputAdorn }} position="end">
    //                 <IconButton>
    //                     <FileCopyOutlined />
    //                 </IconButton>
    //             </InputAdornment>
    //         )
    //     } else {
    //         return (
    //             <InputAdornment classes = {{ filled : classes.RoomTxtInputAdorn }} position="end">
    //             </InputAdornment>
    //         );
    //     }
    // }

    //DEBOUNCE ::
    // const debounceFunction = async (txt) => {
    //     const debounce = await setTimeout( () => { props.textInput(text); }, 500 ); 
    //     return ()=> {
        //         clearTimeout(debounce);
        //     }
        // }